ready(function () {

  const checkLoop = (embla) => {
    const notEnoughToLoop = !embla.internalEngine().slideLooper.canLoop()
    if (notEnoughToLoop) {
      const slidesContainer = embla.slideNodes()[0].parentNode;
      const slides = embla.slideNodes();
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.add('is-clone');
        slidesContainer.appendChild(clone);
      });
      embla.reInit();
    }
  }

  const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
    if (prevBtn) {
      prevBtn.addEventListener('click', embla.scrollPrev, false);
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', embla.scrollNext, false);
    }    
  };

  const updateActiveSlide = (embla) => {
    const slides = embla.slideNodes();
    const setActiveSlide = () => {
      slides.forEach(slide => slide.classList.remove('embla__slide--active'));
      const selectedIndex = embla.selectedScrollSnap();
      slides[selectedIndex].classList.add('embla__slide--active');
    };
    embla.on('init', setActiveSlide);
    embla.on('select', setActiveSlide);
  };  

  const setupEmblaCarousel = (emblaNode) => {
    const viewPort = emblaNode.querySelector(".embla__viewport");
    const prevBtn = emblaNode.querySelector(".embla__button--prev");
    const nextBtn = emblaNode.querySelector(".embla__button--next");

    if (emblaNode.classList.contains('type--banners')) {
      options = { align: 'center', loop: true };
    } else if (emblaNode.classList.contains('type--bannersCollection')) {
      options = { align: 'start', loop: true };
    } else if (emblaNode.classList.contains('type--gallery')) {
      options = { align: 'start', loop: false };
    }

    const embla = EmblaCarousel(viewPort, options);
    checkLoop(embla);
    setupPrevNextBtns(prevBtn, nextBtn, embla);
    updateActiveSlide(embla);
  };

  const emblaNodes = [].slice.call(document.querySelectorAll(".embla"));
  const emblaCarousels = emblaNodes.map(emblaNode => setupEmblaCarousel(emblaNode));

});